const MOJIBAKE_REGEX = /[ÃÂ�]/

export const normalizeUtf8 = (value: string): string => {
  if (!MOJIBAKE_REGEX.test(value)) return value

  try {
    return Buffer.from(value, 'latin1').toString('utf8')
  } catch {
    return value
  }
}
